import {useMuseumsICanSee} from "../museum/useMuseumsICanSee";

export const useHasAccess = () => {
    const museums = useMuseumsICanSee()

    return 1 <= museums.length

}